import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withNamespaces} from 'react-i18next';
import config from '../../config';
import Button from '../../components/Button';
import Card from './components/Card';
import Header from './components/Header';
import {Container} from './styles';

class Home extends Component {
  constructor(props) {
    super(props);

    props.setTitle(null);
  }

  render() {
    const {t} = this.props;
    
    return (
      <Container>
        <Header
          title={t('messages.welcome')}
          description={t('messages.welcomeDescription', {brand: config.brand})} />
        
        <div className="text-center">
          <p>
          {t('messages.welcomeDescription2')}
          </p>
        </div>
        
        <div className="card-deck">
          <Card
            icon="user"
            title={t('newRegistration.title')}
            description={t('newRegistration.description', {brand: config.brand})}>
            <Button to="/sign-up/new">
              {t('newRegistration.button')}
            </Button>
          </Card>
        </div>
      </Container>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setTitle: title => dispatch({type: 'SET_TITLE', payload: title})
});

export default withNamespaces()(connect(null, mapDispatchToProps)(Home));
